import form from './form';

export default {
  form,
};
